import classNames from 'classnames';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { TestBem } from '../../service/TestBem';

import './GridFeedFilterNameCell.css';

export interface GridFeedFilterNameCellProps {
    name: string;
    id: string;
    isCompactViewEnabled: boolean;
}

const BLOCK = 'grid-feed-filter-name-cell';

export class GridFeedFilterNameCell extends React.PureComponent<
    GridFeedFilterNameCellProps
> {
    render() {
        const { name, id, isCompactViewEnabled } = this.props;

        return (
            <div
                className={Bem.cls({
                    block: BLOCK,
                    mods: { compact: isCompactViewEnabled }
                })}
            >
                <h3
                    className={classNames(
                        Bem.cls(BLOCK, 'title'),
                        TestBem.cls(BLOCK, 'title', { id })
                    )}
                >
                    {name}
                </h3>
                <div
                    className={classNames(
                        Bem.cls(BLOCK, 'id'),
                        TestBem.cls(BLOCK, 'id')
                    )}
                >
                    № {id}
                </div>
            </div>
        );
    }
}
